import { createGradientOrSolid } from 'utils';
import styled from 'styled-components';
import { breakpoints } from 'styles/breakpoints';

export const StyledFabelTownSpecialOffer = styled.div`
  font-family: var(--font-family), Arial;
  box-sizing: border-box;
  height: 284px;
  width: 400px;
  max-width: 100%;
  background: ${(props: any) => props.backgroundImage ? `url("${props.backgroundImage}")` : createGradientOrSolid(props.backgroundColor)};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 10px;
  padding: 10px;

  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;

  .special-offer__decorative-block {
    width: 100%;
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.20);
    padding: 20px 8px 10px 8px;
    display: flex;
    flex-direction: column;

    .image-container {
      height: ${(props: any) => props.imageSize || 64}px;
      width: ${(props: any) => props.imageSize || 64}px;

      @media (max-width: ${breakpoints.desktop}) {
        height: ${(props: any) => props.products?.length === 1 ? '64px' : '56px'};
        width: ${(props: any) => props.products?.length === 1 ? '64px' : '56px'};
      }

      @media (max-width: ${breakpoints.mobileXS}) {
        height: ${(props: any) => props.products?.length === 1 ? '60px' : '52px'};
        width: ${(props: any) => props.products?.length === 1 ? '60px' : '52px'};
      }

      .image {
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
    }
  }

  .products-container {
    display: flex;
    justify-content: center;
    gap: 5px;
  }

  .info-container {
    display: flex;
    justify-content: space-between;
    padding: 0 8px;
    margin-top: 30px;
    min-height: 14px;

    p {
      margin: 0;
      font-size: 12px;
      font-weight: 800;
      color: #FFF;
    }
  }

  .amount-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center !important;
    margin-top: 1px;

    .main-amount {
      color: #FFFFFF;
      font-weight: 800;
      text-align: center;
      text-shadow: 
        -0.5px -0.5px 0 #6F0EA2,
        0.5px -0.5px 0 #6F0EA2,
        -0.5px  0.5px 0 #6F0EA2,
        0.5px  0.5px 0 #6F0EA2;
      line-height: 14px;
    }

    .crossed-amount {
      color: #FFF;
      text-align: center;
      text-decoration: line-through;
      font-weight: 800; 
      text-decoration-line: line-through;
      text-decoration-color: #d8232a;
      text-decoration-thickness: 1.5px;
    }
  }

  .price-container {
    width: 172px;
    border: 2px solid #8023D1;
    border-radius: 8px;
    margin-top: 6px;
    font-weight: 200;

    .stroked {
      margin-left: 4px;
      font-weight: 800;
    }

    .final-price {
      font-weight: 800;
    }
  }

  .bundlePriceButton {
    height: 37px;
    border-radius: 7px;
    border: 2px solid #75FFFF;
    width: 100%;
  }
` as any; 